<template>
  <v-layout column>
    <v-form
      ref="form"
      v-model="valid"
    >
      <v-text-field
        v-model="form.firstName"
        :disabled="parsing"
        :rules="[validationRules.required]"
        label="First Name on Card"
        prepend-icon="fa-user"
      />
      <v-text-field
        v-model="form.lastName"
        :disabled="parsing"
        :rules="[validationRules.required]"
        label="Last Name on Card"
        prepend-icon="fa-user"
      />
      <v-text-field
        v-model="form.address"
        :disabled="parsing"
        :rules="[validationRules.required]"
        label="Address"
        prepend-icon="fa-map-marker"
      />
      <v-text-field
        v-model="form.city"
        :disabled="parsing"
        :rules="[validationRules.required]"
        label="City"
        prepend-icon="fa-building"
      />
      <v-text-field
        v-model="form.zip"
        :disabled="parsing"
        :rules="[validationRules.required]"
        label="Zip Code"
        prepend-icon="fa-hashtag"
      />
      <v-text-field
        v-model="form.state"
        :disabled="parsing"
        :rules="[validationRules.required]"
        label="State"
        prepend-icon="fa-monument"
      />
      <v-text-field
        v-model="form.country"
        :disabled="parsing"
        :rules="[validationRules.required]"
        label="Country"
        prepend-icon="fa-globe-americas"
      />
      <v-text-field
        v-model="form.cardNumber"
        :disabled="parsing"
        :rules="[validationRules.required]"
        hint="e.g. 4007000000027"
        persistent-hint
        label="Credit Card Number"
        prepend-icon="fa-credit-card"
      />
      <v-text-field
        v-model="form.month"
        :disabled="parsing"
        :rules="[validationRules.required]"
        label="Expiration Date Month"
        hint="2 digit month (MM)"
        persistent-hint
        prepend-icon="fa-calendar"
      />
      <v-text-field
        v-model="form.year"
        :disabled="parsing"
        :rules="[validationRules.required]"
        label="Expiration Date Year"
        hint="4 digit year (YYYY)"
        persistent-hint
        prepend-icon="fa-calendar"
      />
      <v-text-field
        v-model="form.cardCode"
        :disabled="parsing"
        :rules="[validationRules.required]"
        label="CCV"
        hint="3 digit code found on the back of the card"
        persistent-hint
        prepend-icon="fa-credit-card"
      />
    </v-form>
  </v-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  data () {
    return {
      valid: false,
      form: {
        firstName: null,
        lastName: null,
        address: null,
        city: null,
        state: null,
        zip: null,
        country: null,
        cardNumber: null,
        month: null,
        year: null,
        cardCode: null
      },
      parsing: false,
      cardData: ''
    }
  },
  computed: {
    ...mapGetters({
      person: 'person/person'
    })
  },
  watch: {
    form: {
      handler (val) {
        this.$emit('update', val)
      },
      deep: true
    },
    valid: {
      handler (val) {
        this.$emit('validate', val)
      },
      deep: true
    }
  },
  mounted () {
    // initialize personal info
    this.form.firstName = this.person.firstName
    this.form.lastName = this.person.lastName
    this.form.address = this.person.address1
    this.form.city = this.person.city
    this.form.zip = this.person.zip
    this.form.state = this.person.state
    this.form.country = this.person.country

    window.addEventListener('keypress', this.captureCardData)
  },
  beforeDestroy () {
    window.removeEventListener('keypress', this.captureCardData)
  },
  methods: {
    ...mapActions({
      newNotification: 'info/newNotification'
    }),
    captureCardData (e) {
      if (e.key === ';' || e.key === '%') {
        this.parsing = true
        // focus on temporary field
        const tmp = document.createElement('input')
        document.body.appendChild(tmp)
        tmp.focus()
        document.body.removeChild(tmp)
      }
      if (e.key === '%') {
        this.cardData = ''
      }
      if (this.parsing) {
        this.cardData += e.key
      }
      if (e.key === '?') {
        this.parsing = false
        this.parseCardData()
      }
    },
    parseCardData () {
      let parsedData = this.cardData.match(/%[A-Z](?<cardNumber>\d+)\^(?<lastName>.+)\/(?<firstName>.+)\^(?<year>\d{2})(?<month>\d{2})/i)
      if (!parsedData) {
        this.newNotification({ message: 'Parsing error. Please rescan the card or enter the information manually.' })
        return
      }
      this.form.cardNumber = parsedData.groups.cardNumber
      this.form.lastName = parsedData.groups.lastName
      this.form.firstName = parsedData.groups.firstName
      this.form.year = '20' + parsedData.groups.year // 4 digit year
      this.form.month = parsedData.groups.month
    }
  }
}
</script>
